import { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { DataProvider } from '@happyspace/sdk/data';
import { RestaurantCartProvider } from '@happyspace/sdk/restaurant';

import Navbar from './components/Navbar';
import Footer from './components/Footer';
import CartDrawer from './components/CartDrawer';
import StickyOrderBar from './components/StickyOrderBar';

import Home from './pages/Home';
import Menu from './pages/Menu';
import About from './pages/About';
import Gallery from './pages/Gallery';
import Contact from './pages/Contact';
import OrderConfirmation from './pages/OrderConfirmation';
import OrderStatus from './pages/OrderStatus';
import BlogList from './pages/blog/BlogList';
import BlogPostPage from './pages/blog/BlogPostPage';

function AppShell() {
  const [cartOpen, setCartOpen] = useState(false);

  return (
    <div className="min-h-screen flex flex-col bg-surface">
      <Navbar onCartOpen={() => setCartOpen(true)} />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/menu" element={<Menu />} />
          <Route path="/about" element={<About />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/blog" element={<BlogList />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/order-confirmation" element={<OrderConfirmation />} />
          <Route path="/order-status" element={<OrderStatus />} />
        </Routes>
      </main>
      <Footer />
      <StickyOrderBar onCartOpen={() => setCartOpen(true)} />
      <CartDrawer isOpen={cartOpen} onClose={() => setCartOpen(false)} />
    </div>
  );
}

export default function App() {
  return (
    <HelmetProvider>
      <DataProvider>
        <RestaurantCartProvider>
          <BrowserRouter>
            <AppShell />
          </BrowserRouter>
        </RestaurantCartProvider>
      </DataProvider>
    </HelmetProvider>
  );
}


/* injected: entrance-visibility failsafe — content must never stay invisible */
if (typeof window !== 'undefined') {
  var __hsReveal = function(){
    try {
      document.querySelectorAll('.reveal,.fade-in,.fade-up,[data-reveal],[data-aos]').forEach(function(el){ el.classList.add('in','visible','revealed','active','aos-animate'); });
      document.querySelectorAll('*').forEach(function(el){
        var htmlEl = el as HTMLElement;
        var cs = getComputedStyle(htmlEl);
        if (parseFloat(cs.opacity) < 0.05 && htmlEl.getClientRects().length) {
          htmlEl.style.setProperty('opacity','1','important');
          if (cs.transform && cs.transform !== 'none') htmlEl.style.setProperty('transform','none','important');
        }
      });
    } catch(e){}
  };
  window.addEventListener('load', function(){ setTimeout(__hsReveal, 1500); setTimeout(__hsReveal, 3500); });
}
